import React, { Fragment } from 'react';
import { useParams } from 'react-router-dom';
import useGetSurveyData from './hooks/useGetSurveyData';
import HealthSurveyDisclaimer from './components/HealthSurveyDisclaimer';
import '../css/patientLandingPage.less';
import SurveyContainer from './components/SurveyContainer';
import useSurveys from './hooks/useSurveys';
import useSaveSurveyData from './hooks/useSaveSurveyData';
import useJourneyExpiration from '../PatientLandingGeneralComponents/hooks/useJourneyExpiration';
import { Button, Col, Row } from 'antd';

const HealthSurveyPage = () => {
  const { countryCode } = useParams();
  const { setSurveyDataToSave, finishSurvey } = useSaveSurveyData();
  const surveys = useSurveys({ countryCode, setSurveyDataToSave, finishSurvey });
  const getSurveyData = useGetSurveyData({ surveys, countryCode });
  useJourneyExpiration({ countryCode });

  return (
    <Row justify='center'>
      <Col span={24}>
        <Row justify='end' className='pr-20'>
          <Col span={12}>
            <Button className='cmt-button' type='primary' block style={{ borderRadius: 20 }} onClick={surveys.goBackExams}>
              Ver lista de Exámenes
            </Button>
          </Col>
        </Row>
      </Col>
      <Col span={24}>
        {
          getSurveyData.surveyData &&
          (
            getSurveyData.startedSurvey ?
              <SurveyContainer surveys={surveys} />
              : <HealthSurveyDisclaimer getSurveyData={getSurveyData} />
          )
        }
      </Col>
    </Row>
  )
}

export default HealthSurveyPage;
